// extracted by mini-css-extract-plugin
module.exports = {"container":"Empty_container__1X1an","title":"Empty_title__157Ej","subTitle":"Empty_subTitle__ITmPv","button":"Empty_button__13rl5"};